<template>
  <div class="team-arrival-area-details">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <div class="top-navbar-left">
              <div class="btn-back" @click="$router.push({ name: 'teamArrivalTeamRoute',  params: { 'tid': team_id, 'uid': $route.params.uid } });">
                <font-awesome-icon :icon="['fas', 'angle-left']" />Back
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">Route Details</div>
          </div>

          <div class="col-md-4">
            <!-- <div class="top-navbar-right">
              <button class="btn btn-ecdc">Export Report</button>
            </div> -->
          </div>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="side-filter">
            <div class="title">filter</div>

            <div class="form-group">
              <div class="label">Display Options</div>

              <div class="map-checkbox">
                <div class="custom-control custom-checkbox checkbox-yellow" v-if="tlData">
                  <input type="checkbox" class="custom-control-input" 
                    id="checkbox-tl"
                    value
                    checked
                    @change="checkBoxOnChange($event, tlData, 0, false)">
                  <label class="custom-control-label" for="checkbox-tl">TL</label>
                </div>

                <div class="custom-control custom-checkbox checkbox-pink" v-if="tlData.live_gps">
                  <input type="checkbox" class="custom-control-input" 
                    id="checkbox-tl-live"
                    value
                    checked
                    @change="checkBoxOnChange($event, tlData, 0, true)">
                  <label class="custom-control-label" for="checkbox-tl-live">TL Live</label>
                </div>

                <div class="label mt-4">List of BA</div>

                <div v-if="basData" class="checkbox-ba-list">
                  <div class="custom-control custom-checkbox" v-for="(ba,index) in basData" v-bind:key="ba.id">
                    <input type="checkbox" class="custom-control-input" 
                      value
                      checked
                      :id="index + 100"
                      @change="checkBoxOnChange($event, basData[index], index, false)">
                    <label class="custom-control-label" :for="index + 100">{{ ba.name }}</label>
                  </div>
                
                </div>
              </div>


              <div class="label mt-4">Legend</div>

              <div class="legends">
                  
                <div class="">
                  <img src="../assets/img/legend-checkin.svg" alt="">
                  Check In & Check Out
                </div>
                <div class="">
                  <img src="../assets/img/legend-seq.svg" alt="">
                  Survey Sequence
                </div>
                <div class="">
                  <img src="../assets/img/legend-last.svg" alt="">
                  Last Survey
                </div>
              </div>

              
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8">
          <div id="cdcMap"></div>
        </div>
      </div>
    </div>

    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<script>
import { routeDetailsGPS } from "../api";
import Loader from "./Loader.vue";

export default {
  components: {
    appLoader: Loader
  },
  data() {
    return {
      routeDetailsGpsData: "",
      id: this.$route.params.id,
      venue_id: this.$route.params.venue_id,
      map: "",
      styledMapType: "",
      centerLatLng: "",
      colors: [
        "#FDCD08",
        "#34CEFF",
        "#FF924A",
        "#70D200",
        "#D437E0",
        " #14D0C1",
        "#FF84C7",
        "#857BFF",
        "#FF8080",
        "#CCA500",
        "#E24A4A"
      ],
      tlData: "",
      tlLiveData: "",
      basData: [],
      isLoading: true
    };
  },
  async mounted() {

    this.styledMapType = new window.google.maps.StyledMapType(
      [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#242f3e"
            }
          ]
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#746855"
            }
          ]
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#242f3e"
            }
          ]
        },
        {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "poi.business",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#263c3f"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#6b9a76"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#38414e"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#212a37"
            }
          ]
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9ca5b3"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#746855"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#1f2835"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#f3d19c"
            }
          ]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#2f3948"
            }
          ]
        },
        {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#d59563"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#17263c"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#515c6d"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#17263c"
            }
          ]
        }
      ],
      { name: "Styled Map" }
    );

    await this.getData();
    this.isLoading = false;
  },
  methods: {
    async getData() {

      const _this = this;

      try {

        const result = await routeDetailsGPS({ work_progress_tl_id: this.id, venue_id: this.venue_id });
        this.routeDetailsGpsData = result.data.data;

        if(this.routeDetailsGpsData) {

          this.routeDetailsGpsData.forEach(function(item) {

          if (item.position_id == 44) {
              _this.tlData = item;
          } else {
              _this.basData.push(item);
            }
          });

          if (this.tlData.live_gps != undefined) {
            this.centerLatLng = {
              lat: parseFloat(this.tlData.live_gps.latitude),
              lng: parseFloat(this.tlData.live_gps.longitude)
            };
          } else {
            this.centerLatLng = {
              lat: parseFloat(this.tlData.latitude),
              lng: parseFloat(this.tlData.longitude)
            };
          }

          this.map = new window.google.maps.Map(document.getElementById("cdcMap"), {
            center: this.centerLatLng,
            scrollwheel: false,
            zoom: 19
          });
          this.map.mapTypes.set("styled_map", this.styledMapType);
          this.map.setMapTypeId("styled_map");

          

          // this.tlData = this.routeDetailsGpsData;
          // this.basData = this.routeDetailsGpsData.ba_array;

          if(this.tlData)
            _this.pinPointLocation(this.tlData, 0, false);

          if(this.tlData.live_gps != undefined) {

            _this.pinPointLocation(this.tlData, 0, true);
          }

          this.basData.forEach(function(item, index) {

            _this.pinPointLocation(item, index, false);
          });
        }
      }
      catch(err) {

          alert(err);
      }
    },
    checkBoxOnChange(event, data, baIndex, isLive) {

      if (event.target.checked) {

        this.pinPointLocation(data, baIndex, isLive);
      }
      else {

        if(isLive) {

          data.liveCheckInMarker.setMap(null);

          data.liveCheckInMarker = "";
        }
        else {

          data.checkInMarker.setMap(null);

          if (data.engagementsMarkers != undefined) {
            data.engagementsMarkers.forEach(function(item) {
              item.setMap(null);
            });
          }

          data.checkInMarker = "";
          data.engagementsMarker = [];
        }
      }
    },
    pinPointLocation(data, baIndex, isLive) {

      const _this = this;

      var image = "";

      if(isLive) {

        image = require("@/assets/img/pin-live.svg");

        data.liveCheckInMarker = new window.google.maps.Marker({
          position: {
            lat: parseFloat(data.live_gps.latitude),
            lng: parseFloat(data.live_gps.longitude)
          },
          animation: window.google.maps.Animation.DROP,
          map: _this.map,
          icon: image,
          title: data.user_name
        });
      }
      else {

        image = require("@/assets/img/pin-in-" + (data.position_id == 44?0:baIndex + 1) + ".svg");

        data.checkInMarker = new window.google.maps.Marker({
          position: {
            lat: parseFloat(data.latitude),
            lng: parseFloat(data.longitude)
          },
          animation: window.google.maps.Animation.DROP,
          map: _this.map,
          icon: image,
          title: data.user_name
        });
      }
      
      data.engagementsMarkers = [];

        data.engagements.forEach(function(engage, index, array) {

          var template = [
            '<?xml version="1.0"?>',
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="29" height="29" viewBox="0 0 29 29">',
            '<defs><filter id="Ellipse_124" x="0" y="0" width="29" height="29" filterUnits="userSpaceOnUse"><feOffset input="SourceAlpha"/><feGaussianBlur stdDeviation="1.5" result="blur"/><feFlood flood-opacity="0.302"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs>',
            '<g id="Group_702" data-name="Group 702" transform="translate(-631.5 -520.5)">',
            '<g transform="matrix(1, 0, 0, 1, 631.5, 520.5)" filter="url(#Ellipse_124)">',
            '<circle id="Ellipse_124-2" data-name="Ellipse 124" cx="10" cy="10" r="10" transform="translate(4.5 4.5)" fill="' +
              _this.colors[data.position_id == 45 ? baIndex + 1 : baIndex] +
              '"/>',
            "</g>",
            '<text id="_2" data-name="2" transform="translate(649 538.5)" fill="#fff" font-size="10" font-family="Gotham-Bold, Gotham" font-weight="700" text-anchor="middle">',
            '<tspan x="-3.115" y="0">',
            (index + 1),
            "</tspan>",
            "</text>",
            "</g>",
            "</svg>"
          ].join("\n");

          if (index === array.length - 1) {
            template = [
              '<?xml version="1.0"?>',
              '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="61" height="51" viewBox="0 0 61 51"> <defs> <filter id="Polygon_2" x="0" y="0" width="61" height="51" filterUnits="userSpaceOnUse"> <feOffset input="SourceAlpha"/> <feGaussianBlur stdDeviation="1.5" result="blur"/> <feFlood flood-opacity="0.302"/> <feComposite operator="in" in2="blur"/> <feComposite in="SourceGraphic"/> </filter> </defs> <g id="Group_497" data-name="Group 497" transform="translate(-627.5 -522.623)"> <g transform="matrix(1, 0, 0, 1, 627.5, 522.62)" filter="url(#Polygon_2)">',
              '<path id="Polygon_2-2" data-name="Polygon 2" d="M26,0,52,42H0Z" transform="translate(56.5 46.5) rotate(180)" fill="' +
                _this.colors[data.position_id == 45 ? baIndex + 1 : baIndex] +
                '"/>',
              '</g><text class="pin-test" id="_5" data-name="5" transform="translate(664.5 548.123)" fill="#fff" font-size="20" font-family="Gotham-Bold, Gotham" font-weight="700" text-anchor="middle"><tspan x="-6.3" y="0">' +
                (index + 1),
                "</tspan></text></g></svg>"
            ].join("\n");
          }

          var engagementsMarker = new window.google.maps.Marker({
            position: {
              lat: parseFloat(engage.latitude),
              lng: parseFloat(engage.longitude)
            },
            map: _this.map,
            animation: window.google.maps.Animation.DROP,
            icon: {
              url:
                "data:image/svg+xml;charset=UTF-8," +
                encodeURIComponent(template),
              scaledSize: new window.google.maps.Size(40, 40)
            },
            title: engage.id.toString()
          });

          data.engagementsMarkers.push(engagementsMarker);
        });
    }
  }
};
</script>

<style scoped>
#cdcMap {
  width: 100%;
  height: 800px;
}
</style>